import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Clients, Earnings } from "../../../Utils/Constants";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import { H3, H5, Image, LI, UL } from "../../../AbstractElements";

const ClientAndEarningCard = () => {
  return (
    <Col xxl="2" xl="4" md="5" className="order-item-1 box-col-5">
      <Row>
        <Col md="12" sm="6">
          <Card className="since">
            <CardBody>
              <div className="customer-card d-flex b-l-primary border-2">
                <div className="ms-3">
                  <H3 className="mt-1">{Clients}</H3>
                  <H5 className="mt-1">2.536</H5>
                </div>
                <div className="dashboard-user bg-light-primary">
                  <span />
                  <SvgIcon iconId="male" />
                </div>
              </div>
              <div className="customers text-center social-group">
                <UL className="d-flex simple-list flex-row">
                  {dynamicNumber(5).map((data, index) => (
                    <LI key={index} className="d-inline-block">
                      <Image className="img-30 rounded-circle" src={dynamicImage(`dashboard/user/${data}.png`)} alt="userImage"/>
                    </LI>
                  ))}
                </UL>
              </div>
              <div className="customer mt-2">
                <span className="me-1">
                  <SvgIcon iconId="arrow-up" />
                </span>
                <span className="font-success me-2">+ 4.6%</span>
                <span>{'Since last Week'}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md="12" sm="6">
          <Card className="since">
            <CardBody className="money">
              <div className="customer-card d-flex b-l-secondary border-2">
                <div className="ms-3">
                  <H3 className="mt-1">{Earnings}</H3>
                  <H5 className="mt-1">$6.642</H5>
                </div>
                <div className="dashboard-user bg-light-secondary">
                  <span />
                  <SvgIcon iconId="money" />
                </div>
              </div>
              <div className="customer mt-2">
                <span className="me-1">
                  <SvgIcon iconId="arrow-up" />
                </span>
                <span className="font-success me-2">+ 3.5%</span>
                <span>{'Since last Week'}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Col>
  );
};
export default ClientAndEarningCard;
